import { apiRequest } from '@/utils/api-request';
import * as Sentry from '@sentry/react';

// Mirror of the pause-side response: the authoritative resumed state, with the
// shifted deadline, arrives over WS.
export interface ResumeClarificationCountdownResponse {
  success: boolean;
  message: string;
  session_id: string;
  detail?: string;
}

/**
 * Resume the workflow's clarification countdown timer.
 *
 * Resuming while not paused is a no-op, so firing liberally is safe.
 */
export const resumeClarificationCountdown = async (
  workflowId: string,
  sessionId: string,
  orgId: string,
): Promise<ResumeClarificationCountdownResponse> => {
  try {
    const response = await apiRequest<ResumeClarificationCountdownResponse>({
      url: `/api/v1/orgs/${orgId}/workflows/${workflowId}/runs/session/${sessionId}/resume-clarification-countdown`,
      method: 'POST',
      target: 'workflow',
    });
    if (response?.detail) {
      throw new Error(response.detail);
    }
    const data = (response?.data ?? response) as
      | ResumeClarificationCountdownResponse
      | undefined;
    if (!data || data.success === false) {
      throw new Error(
        data?.detail ||
          data?.message ||
          'Resume-countdown signal was not accepted by the backend',
      );
    }
    return data;
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        context: 'resume-clarification-countdown',
        workflowId,
        sessionId,
      },
    });
    throw error;
  }
};
